import React, { FC, ComponentProps } from 'react';
import { useIntl } from 'dibs-react-intl';
import { LOCALE_DE, LOCALE_FR } from 'dibs-intl/exports/locales';

const Unavailable = React.lazy(() => import('dibs-icons/exports/Unavailable'));
const UnavailableDe = React.lazy(() => import('dibs-icons/exports/UnavailableDe'));
const UnavailableFr = React.lazy(() => import('dibs-icons/exports/UnavailableFr'));

type Props = ComponentProps<typeof Unavailable | typeof UnavailableFr | typeof UnavailableDe>;

export const LocalizedUnavailableIcon: FC<Props> = props => {
    const { locale } = useIntl();

    if (locale === LOCALE_DE) {
        return <UnavailableDe {...props} />;
    }

    if (locale === LOCALE_FR) {
        return <UnavailableFr {...props} />;
    }

    return <Unavailable {...props} />;
};
